import { Theme, theme as udsTheme } from '@updater/ui-uds';

export const baseTheme: Theme = {
  ...udsTheme,
};
